"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _endpoints = require("./endpoints.js");
var _intlTools = require("@nackle/intl-tools");
async function _default(token, bundleName, locale) {
  try {
    const response = await fetch(`${_endpoints.cmxUrl}/bundle/${encodeURIComponent(bundleName)}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        locales: [locale]
      })
    });
    if (response.ok) {
      const bundle = await response.json();
      (0, _intlTools.updateLanguageBundle)(bundle.bundles[locale]);
      return {
        success: true
      };
    } else {
      return {
        success: false
      };
    }
  } catch (error) {
    return {
      success: false
    };
  }
}
//# sourceMappingURL=content.js.map